const generateVoiceRecordingRandomSuffix = (length = 6) =>
  Math.random()
    .toString()
    .slice(2, 2 + length)

export const generateVoiceRecordingName = () =>
  `VoiceRecord_${generateVoiceRecordingRandomSuffix()}.mp3`
export const isVoiceRecordingName = (name: string) => /VoiceRecord_[0-9]{6}\.mp3/.test(name)
